import * as React from "react"
import {useMemo, useEffect, useRef} from "react"
import {AutocompleteAsyncSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import {createBatchFormData} from "../../@signals"


export default function SkusAutocomplete({...props}) {
	const customerID = createBatchFormData.value.customerID
	const brands = createBatchFormData.value.brands
	
	// Build filters for SKU search
	const filters = useMemo(() => {
		const f = {}
		if (customerID) f.customerID = customerID
		if (brands && brands.length > 0) f.brandID = brands
		return f
	}, [customerID, brands])
	
	// Track previous values to detect actual changes
	const prevCustomerID = useRef(customerID)
	const prevBrandIDs = useRef(JSON.stringify(brands?.map(b => b.value || b).sort()))
	
	// Reset SKUs only when customer or brands actually change
	useEffect(() => {
		const currentBrandIDs = JSON.stringify(brands?.map(b => b.value || b).sort())
		const customerChanged = prevCustomerID.current !== customerID
		const brandsChanged = prevBrandIDs.current !== currentBrandIDs
		
		if ((customerChanged || brandsChanged) && createBatchFormData.value.skus?.length > 0) {
			createBatchFormData.value = {...createBatchFormData.value, skus: []}
		}
		
		prevCustomerID.current = customerID
		prevBrandIDs.current = currentBrandIDs
	}, [customerID, brands])
	
	return <AutocompleteAsyncSeeker
		multiple
		urlAjax={`${BACKEND_APIS.BATCH_ADMIN}/skus`}
		label="SKUs"
		placeholder={customerID ? "Search SKUs..." : "Select a Customer first"}
		value={createBatchFormData.value.skus || []}
		onChange={e => createBatchFormData.value = {...createBatchFormData.value, skus: e.target.value}}
		queryParam="search"
		filters={filters}
		keepValue
		disabled={!customerID}
		{...props}
	/>
}
